import {
    //TableDataRow,
    //scroll,
    // tableFieldType,
    // tableFieldName,
    TableSelection,
} from 'sdi/components/table2';
import {
    dispatchK,
    assignK,
    dispatch, //query,
    assign,
} from 'sdi/shape';
import {
    deleteLinkedIssues,
    fetchAllUsers,
    LinkedIssues,
    postLinkedIssues,
    putLinkedIssues,
} from '../remote';
import { getApiUrl } from 'sdi/app';
import {
    findIssue,
    getFilterCriticality,
    getIssueList,
    //getLastSelectedIssue,
    getLinkedIssuesList,
    getSelectedLinkedGroup,
} from '../queries/qa';
import {
    getFilteredAndSortedRows,
    getSelectedIssueIds,
    //layerSource,
} from '../queries/table';
import {
    clearSelectedIssues,
    deselectIssue,
    loadLinkedIssues,
    removeLinkedIssuesRemote,
    selectIssue,
    //selectLinkedGroup,
} from './qa';
//import { navigateClear, navigateToSelection } from './route';
import { Coordinate } from 'ol/coordinate';
import { getChangeLinkGroup, getTheme } from '../queries/app';
import { setLinkChangeId } from './app';
import { navigateClear, navigateToSelection } from './route';
import { index } from 'fp-ts/lib/Array';
//import { cellToString } from 'sdi/components/table2/render';

export const tableDispatch = dispatchK('component/table');

export const coordToOpenLayerCoord = (coord: number[]) => {
    if (coord.length === 2) {
        const newCoord: Coordinate = [coord[0], coord[1]];
        return newCoord;
    } else {
        return [261446.19, 6250011.67] as Coordinate;
    }
};

export const clearRowSelection = (issueId: number) =>
    dispatch('component/table', s => ({
        ...s,
        //selected: s.selected.filter(id => id !== issueId),
        selected: s.selected.filter(({ from }) => from !== issueId), //TOCHECK
    }));
export const clearRowSelectionAll = () =>
    dispatch('component/table', s => ({
        ...s,
        selected: [],
    }));
export const selectRow = (_selected: number) =>
    dispatch('component/table', s => ({
        ...s,
        selected: s.selected, //s.selected.concat(selected), //TODO
    }));

// const updateLinkedIssues = (id: number, newLinkedIssues: LinkedIssues) => putLinkedIssues(id, newLinkedIssues);
// .then(() => {
//     const newLinkedIssuesList = getLinkedIssuesList...
// }) //TODO!!!

export const createLinkedGroup = (issueId: number) =>
    postLinkedIssues({ link: 'MANUAL', issues: [issueId] }).then(li => {
        const newLinkedIssuesList = getLinkedIssuesList().concat(li); // TODO: update remote linkedissues!!
        assign('qa/issues/linked', newLinkedIssuesList);
        removeLinkedIssuesRemote(issueId);
        loadLinkedIssues(issueId);
        setLinkChangeId(li.id);
    });
// .catch(err => assign('qa/issues/linked/remote', remoteError(err.toString()));

// const addLinkedIssue = (group: LinkedIssues, issueId: number) => {
//     const newIssueList = group.issues
//         .filter(i => i !== issueId)
//         .concat(issueId);
//     const newGroup: LinkedIssues = {
//         ...group,
//         issues: newIssueList,
//     };
//     selectLinkedGroup(newGroup);
//     return updateLinkedIssues(newGroup, issueId);
// };

const updateLinkedIssues = (newGroup: LinkedIssues, issueId: number) =>
    putLinkedIssues(newGroup.id, newGroup).then(li => {
        const newLinkedIssuesList = getLinkedIssuesList()
            .filter(e => e.id !== newGroup.id)
            .concat(li);
        assign('qa/issues/linked', newLinkedIssuesList);
        removeLinkedIssuesRemote(issueId);
        loadLinkedIssues(issueId);
        // selectLinkedGroup(li);
    });
// .catch(err => assign('qa/issues/linked/remote', remoteError(err.toString()));

const deleteAndUpdateLinkedIssue = (issueId: number, id: number) => {
    deleteLinkedIssues(id).then(() => {
        const newLinkedIssuesList = getLinkedIssuesList().filter(
            e => e.id !== id
        );
        assign('qa/issues/linked', newLinkedIssuesList);
        removeLinkedIssuesRemote(issueId);
        loadLinkedIssues(issueId);
    });
};

export const deleteLinkedIssue = (issueId: number) => {
    getChangeLinkGroup().map(lg => {
        const newIssuesList = lg.issues.filter(i => i !== issueId);
        const newGroup: LinkedIssues = {
            ...lg,
            issues: newIssuesList,
        };
        newIssuesList.length > 0
            ? updateLinkedIssues(newGroup, issueId)
            : deleteAndUpdateLinkedIssue(issueId, lg.id);
    });
};

// export const selectIssueFromRow = (row: TableDataRow, selected: number) => {
//     if (getLayout() === 'tableSelect') { //TODO implement?
//         getLastSelectedIssue().map(i => {
//             navigateToSelection('issue', i.id);
//         });
//         getChangeLinkGroup().map(lg => {
//             addLinkedIssue(lg, selected);
//         });
//         // setAddLinkStatus(false);
//     } else {
//         findIssue(row.from).map(issue => {
//             if (getSelectedIssueIds().indexOf(issue.id) >= 0) {
//                 deselectIssue(issue);
//                 clearRowSelection(issue.id);
//                 navigateClear();
//             } else {
//                 clearRowSelectionAll();
//                 clearSelectedIssues();
//                 selectRow(issue.id);
//                 selectIssue(issue.id);
//                 navigateToSelection('issue', selected);
//             }
//         });
//     }
// };

export const selectIssueFromRow = (rows: TableSelection) =>
    index(0, rows).map(row =>
        findIssue(row.from).map(issue => {
            if (getSelectedIssueIds().indexOf(issue.id) >= 0) {
                deselectIssue(issue);
                clearRowSelection(issue.id);
                navigateClear();
            } else {
                clearRowSelectionAll();
                clearSelectedIssues();
                selectRow(issue.id);
                selectIssue(issue.id);
                getTheme().map(theme => navigateToSelection(theme, issue.id));
            }
        })
    );

// export const scrollToIssue = (issueId: number) =>
//     rowIndexFromId(issueId).map(offset => {
//         scroll('table-issues', offset * query('component/table').rowHeight);
//     });

export const rowIndexFromId = (issueId: number) =>
    getIssueList()
        .map(getFilteredAndSortedRows)
        .map(rows => rows.findIndex(row => row.from === issueId));

export const isFilteredTable = () =>
    getSelectedLinkedGroup().isSome() || getFilterCriticality().isSome();

export const fetchAllUsersEvents = () =>
    fetchAllUsers(getApiUrl('users'))
        .then(assignK('data/users'))
        .catch(err => console.error('cannot load users', err));

export const setTableTitle = (title: string) =>
    assign('component/table/title', title);
export const clearTableTitle = () => assign('component/table/title', null);

// export const extractAsCSV = (tableName: string) => {
//     const separator = ';';
//     const filename = tableName + '.csv';
//     let csvContent = '';
//     const source = layerSource();
//     const types = source.fields.map(tableFieldType);

//     // Append keys as CSV header
//     csvContent += source.fields.map(tableFieldName).join(separator) + '\r\n';
//     // Append values
//     source
//         .data({ offset: 0, size: Number.MAX_SAFE_INTEGER })
//         .rows.forEach(rowValue => {
//             if (rowValue.cells.length === types.length) {
//                 const row = rowValue.cells
//                     .map((cell, i) => cellToString(cell, types[i]))
//                     .join(separator);
//                 csvContent += row + '\r\n';
//             }
//         });

//     // Create the blob
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);

//     // Download
//     if (navigator.msSaveBlob) {
//         navigator.msSaveBlob(blob, filename);
//     } else {
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = filename;
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);
//     }
//     window.URL.revokeObjectURL(url);
// };
